"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Header = exports.Footer = exports.Body = void 0;
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _index = _interopRequireDefault(require("../Link/index"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var Header = function Header(props) {
  var className = props.className,
    style = props.style,
    children = props.children,
    showBackButton = props.showBackButton,
    backButtonText = props.backButtonText,
    _props$onBackButtonCl = props.onBackButtonClick,
    onBackButtonClick = _props$onBackButtonCl === void 0 ? function () {
      return null;
    } : _props$onBackButtonCl,
    operation = props.operation;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("layout__content-header");
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, !children && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--title")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--justify")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--left ").concat(prefixCls, "--grid")
  }, showBackButton && /*#__PURE__*/_react.default.createElement(_index.default, {
    size: "l",
    className: "".concat(prefixCls, "--back"),
    type: "weak-arrow-left",
    onClick: onBackButtonClick
  }, backButtonText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "--right ").concat(prefixCls, "--grid")
  }, operation))), !!children && children);
};
exports.Header = Header;
var Body = function Body(props) {
  var className = props.className,
    style = props.style,
    children = props.children;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("layout__content-body");
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, children);
};
exports.Body = Body;
var Footer = function Footer(props) {
  var className = props.className,
    style = props.style,
    children = props.children;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("layout__content-footer");
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, children);
};
exports.Footer = Footer;
var LayoutContent = function LayoutContent(props) {
  var className = props.className,
    style = props.style,
    children = props.children,
    padding = props.padding;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("layout__content");
  var classes = (0, _classnames.default)(prefixCls, {
    'is-padding': !!padding
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-inner")
  }, children));
};
var _default = LayoutContent;
exports.default = _default;